/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Chat {

    @Serenity.Decorators.panel()
    @Serenity.Decorators.registerClass()
    export class ChatlinkcontactsDialog extends NoboxEntityDialog<ChatlinkcontactsRow, any> {
        protected getFormKey() { return ChatlinkcontactsForm.formKey; }
        protected getIdProperty() { return ChatlinkcontactsRow.idProperty; }
        protected getLocalTextPrefix() { return ChatlinkcontactsRow.localTextPrefix; }
        protected getNameProperty() { return ChatlinkcontactsRow.nameProperty; }
        protected getService() { return ChatlinkcontactsService.baseUrl; }
        protected getDeletePermission() { return ChatlinkcontactsRow.deletePermission; }
        protected getInsertPermission() { return ChatlinkcontactsRow.insertPermission; }
        protected getUpdatePermission() { return ChatlinkcontactsRow.updatePermission; }

        protected form = new ChatlinkcontactsForm(this.idPrefix);

        private conversationsGrid: LinkConversationGrid;
        private campaigntargetsGrid: Nobox.LinkBroadcastGrid;
        public linkgrid: any;

        constructor(container?: JQuery) {
            super(container);
            this.conversationsGrid = new LinkConversationGrid(this.byId('ConversationsGrid'));
            this.conversationsGrid.openDialogsAsPanel = true;
            this.campaigntargetsGrid = new Nobox.LinkBroadcastGrid(this.byId('CampaignsGrid'));
            this.campaigntargetsGrid.openDialogsAsPanel = true;
        }
        loadEntity(entity: ChatlinkcontactsRow) {
            super.loadEntity(entity);
            Serenity.TabsExtensions.setDisabled(this.tabs, 'Conversation', this.isNewOrDeleted());
            Serenity.TabsExtensions.setDisabled(this.tabs, 'Campaign', this.isNewOrDeleted());
            if (this.isNewOrDeleted()) {
                this.form.In.element.closest('.category').toggle(false);
            }
            if (this.isEditMode()) {
                this.formChannel(entity.ChId);
                if (entity.ChId != null && entity.ChId != 0) {
                    this.form.IdExt.getGridField().toggle(true);
                } else {
                    this.form.IdExt.getGridField().toggle(false);
                }
                if (entity.ChId == 2) {
                    this.form.Extra.getGridField().toggle(false);
                } else {
                    this.form.Extra.getGridField().toggle(true);
                }
                this.conversationsGrid.contactId = `${entity.Id}`;
                this.campaigntargetsGrid.contactlinkid = `${entity.Id}`;
            }
        }
        protected updateInterface() {
            super.updateInterface();
            var $form = this.form;
            var $this = this;
            if (this.isEditMode()) {
                $this.formChannel($this.get_entity().ChId);
                //$this.formAccount($this.get_entity().AccId);
                if ($this.get_entity().ChId == 2 && !Q.isEmptyOrNull($this.get_entity().Extra)) {
                    var objTele = JSON.parse($this.get_entity().Extra) as any;
                    this.form.ExtId.value = objTele.ExtId;
                    this.form.Username.value = objTele.Username;
                    this.form.AccessHash.value = objTele.AccessHash;
                }
            }
            $form.ChId.element.on("change", function () {
                $this.formChannel($form.ChId.value);
                if (!Q.isEmptyOrNull($form.ChId.value)) {
                    $form.IdExt.getGridField().toggle(true);
                } else {
                    $form.IdExt.getGridField().toggle(false);
                }
                if ($form.ChId.value == "2") {
                    $form.Extra.getGridField().toggle(false);
                } else {
                    $form.Extra.getGridField().toggle(true);
                }
            });
            //$form.AccId.element.on("change", function () {
            //    $this.formAccount($form.AccId.value);
            //    if ($this.isEditMode()) {
            //        if ($this.get_entity().AccId.toString() == $form.AccId.value) {
            //            Serenity.EditorUtils.setValue($form.IdExt, $this.get_entity().IdExt);
            //        } else {
            //            Serenity.EditorUtils.setValue($form.IdExt, null);
            //        }
            //    }
            //});
        }
        protected formChannel(channel) {
            var $form = this.form;
            if (channel == 1) {
                $form.IdExt.getGridField().find(".caption").html(`<sup title="this field is required">*</sup>Phone Number`);
                $form.IdExt.getGridField().find(".editor").attr("placeholder", "628xxx");
            } else if (channel == 2) {
                $form.IdExt.getGridField().find(".caption").html(`<sup title="this field is required">*</sup>External Id`);
                $form.IdExt.getGridField().find(".editor").attr("placeholder", "628xxx");
            } else if (channel == 19) {
                $form.IdExt.getGridField().find(".caption").html(`<sup title="this field is required">*</sup>Email Address`);
                $form.IdExt.getGridField().find(".editor").attr("placeholder", "example@gmail.com");
            }
            var kondisiTele = false;
            if (channel == 2) {
                kondisiTele = true;
            }
            this.form.ExtId.getGridField().toggle(kondisiTele);
            this.form.Username.getGridField().toggle(kondisiTele);
            this.form.AccessHash.getGridField().toggle(kondisiTele);
        }
        protected formAccount(account) {
            var $form = this.form;
            if (!Q.isEmptyOrNull(account)) {
                $form.IdExt.getGridField().toggle(true);
            } else {
                $form.IdExt.getGridField().toggle(false);
            }
        }
        dialogClose() {
            super.dialogClose();
            if (this.linkgrid) {
                this.linkgrid.refresh();
            }
        }
        //protected save() {
        //    super.save();
        //}
        //protected onSaveSuccess(response) {
        //    super.onSaveSuccess(response);
        //    //this.dialogClose();
        //    //this.linkgrid.refresh();
        //}
        getTemplate() {
            return `<div id="~_Tabs" class="s-DialogContent">
                        <ul>
                            <li><a href="#~_TabContact"><span>Info</span></a></li>
                            <li><a href="#~_TabConversation"><span>Conversations</span></a></li>
                            <li><a href="#~_TabCampaign"><span>Broadcast Messages</span></a></li>
                        </ul>
                        <div id="~_TabContact" class="tab-pane s-TabContact">
                            <div id="~_Toolbar" class="s-DialogToolbar">
                            </div>
                            <div class="s-Form">
                                <form id="~_Form" action="">
                                    <div class="fieldset ui-widget ui-widget-content ui-corner-all">
                                        <div id="~_PropertyGrid"></div>
                                        <div class="clear"></div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div id="~_TabConversation" class="tab-pane s-TabConversation">
                            <div id="~_ConversationsGrid">
                            </div>
                        </div>
                        <div id="~_TabCampaign" class="tab-pane s-TabCampaign">
                            <div id="~_CampaignsGrid">
                            </div>
                        </div>
                    </div>`;
        }
    }
}